<template>
  <section class="coming_soon_content">
    <div class="container">
      <div class="row">
        <div class="col-md-5">
          <h1>Muy Pronto</h1>
          <h3>Estaremos lanzando nuestro nuevo portal.</h3>
          <div class="timer_countdown">
            <div id="countdown" class="countdown styled"></div>
          </div>
        </div>
        <div class="col-md-7"> <img src="assets/images/755x430.png" alt="image"> </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>

</style>